import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_server_page = _resolveComponent("g-server-page");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        "show-logo": _ctx.$appHost.pageMeta?.options?.showLogo ?? false,
        title: _ctx.$appHost.pageMeta.title,
        "back-link-path": "/login"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_g_server_page, { templateUrl: "`identity/register/done`" })
        ]),
        _: 1
    }, 8, ["show-logo", "title"]));
}
